import type { Feature, FeatureModule } from '../../../../types';
import { featureList } from '../../../helpers';
import { ASSETS_DESCRIPTION_FEATURE_GROUP } from './group';

export const ASSETS_DESCRIPTION_FEATURES = {
  READ: {
    guid: 'd4e6f201-9a3b-4c57-b183-6c7d8e2f0001',
    name: 'assets:description:read',
    description: 'View SEO metadata and analytics code settings',
    action: 'read',
    product: 'account',
    parentGuid: ASSETS_DESCRIPTION_FEATURE_GROUP.guid,
  },
  UPDATE: {
    guid: 'd4e6f201-9a3b-4c57-b183-6c7d8e2f0002',
    name: 'assets:description:update',
    description: 'Edit SEO metadata and analytics code settings',
    action: 'update',
    product: 'account',
    parentGuid: ASSETS_DESCRIPTION_FEATURE_GROUP.guid,
  },
} as const satisfies Record<string, Feature>;

export { ASSETS_DESCRIPTION_FEATURE_GROUP } from './group';

export const ASSETS_DESCRIPTION_MODULE: FeatureModule = {
  product: 'account',
  groups: [ASSETS_DESCRIPTION_FEATURE_GROUP],
  features: featureList(ASSETS_DESCRIPTION_FEATURES),
};
